module.exports = __webpack_public_path__ + "static/media/md-shuffle.3e299649.svg";